<template>
    <div class="row row-eq-height main__boxes">
        <points-widget color="box--dark-blue"></points-widget>
        <rules-widget v-if="prizes!=true" color="box--blue"></rules-widget>
        <prizes-widget v-if="prizes==true" color="box--blue"></prizes-widget>
        <invoices-widget color="box--green"></invoices-widget>
    </div>
</template>
<script>
    export default {
        name: 'PageBoxSetWidget',
        props: {
            prizes: {
                default: true
            }
        },
        data () {
            return {
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/home/boxSets/PageBoxSetWidget.vue